/**
 * WebMCP API Registration for AI Agent Discovery
 * Per https://webmachinelearning.github.io/webmcp/ and Chrome EPP
 */
export function initWebMcp(): () => void {
  if (
    typeof navigator === "undefined" ||
    !("modelContext" in navigator) ||
    typeof (navigator as any).modelContext?.registerTool !== "function"
  ) {
    return () => {};
  }

  const ac = new AbortController();

  try {
    const mc = (navigator as any).modelContext;

    mc.registerTool(
      {
        name: "searchProducts",
        description: "Search FN Atelier luxury electronics, audio, and accessories",
        inputSchema: {
          type: "object",
          properties: {
            query: { type: "string", description: "Search query" },
          },
          required: ["query"],
        },
        execute: async ({ query }: { query: string }) => {
          return {
            status: "success",
            query,
            resultsUrl: `https://store.flamesnova.name.ng/search?q=${encodeURIComponent(query)}`,
          };
        },
      },
      { signal: ac.signal },
    );

    mc.registerTool(
      {
        name: "checkTelecomRates",
        description: "Check live rates for mobile data bundles and airtime on Flames Nova",
        inputSchema: {
          type: "object",
          properties: {
            network: { type: "string", description: "Network (MTN, GLO, AIRTEL, 9MOBILE)" },
          },
        },
        execute: async ({ network }: { network?: string }) => {
          return {
            status: "success",
            network: network || "all",
            rates: "MTN 1GB ₦450, Glo 1GB ₦335, Airtel 1GB ₦338, 9mobile 1GB ₦500",
          };
        },
      },
      { signal: ac.signal },
    );

    mc.registerTool(
      {
        name: "queryFlamesNovaAi",
        description: "Ask Flames Nova AI assistant questions and SEO tasks",
        inputSchema: {
          type: "object",
          properties: {
            prompt: { type: "string", description: "User query for Flames Nova AI" },
          },
          required: ["prompt"],
        },
        execute: async ({ prompt }: { prompt: string }) => {
          return { status: "success", prompt, aiEndpoint: "https://ai.flamesnova.name.ng/chat" };
        },
      },
      { signal: ac.signal },
    );
  } catch (err) {
    console.warn("WebMCP registration failed:", err);
  }

  return () => {
    ac.abort();
  };
}
